import { z } from "zod";

export const ScoreItemSchema = z.object({
  slideId: z.string(),
  score: z.number(),
});

export const LessonViewSchema = z.object({
  isDone: z.boolean(),
  lessonId: z.string(),
  scores: z.array(z.array(ScoreItemSchema)),
  scoresTable: z.record(z.string(), z.number()).nullish(),
  userId: z.string(),
  lessonName: z.string().optional(),
  projectPath: z.array(z.string()).optional(),
});

export type ScoreItem = z.infer<typeof ScoreItemSchema>;
export type LessonView = z.infer<typeof LessonViewSchema>;
